import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getHeader} from "../../../_fri/utils/function";
import {FindCurrentSaleFindRequest, FindCurrentSaleFindResponse} from "../interface/demo";
export const demo = createApi({

        reducerPath: "demo",
        baseQuery: fetchBaseQuery({
            baseUrl: `${process.env.REACT_APP_API_URL}/business/processors/v2/demo/orders/current/`,
            prepareHeaders: (headers, {getState}) => {
                return getHeader(headers, getState);
            },
        }),
        endpoints: (builder) => ({
            findCurrentSale: builder.mutation<FindCurrentSaleFindResponse, FindCurrentSaleFindRequest>({
                query: (data) => ({
                    url: `find`,
                    method: "Post",
                    body: data,
                }),
            })
        }),
    })
;

export const {
    useFindCurrentSaleMutation
} = demo;
